import { AppStyled, GlobalStyle } from 'GlobalStyle';
import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { init } from './Libs/apollo';
import Routes from './Routes';
import AuthStore from 'Store/AuthStore';
import UiStore from 'Store/UiStore';
import ConfigurationStore from 'Store/ConfigurationStore';
import DesignStore from 'Store/DesignStore';
import InitiStoreApp from 'Store/InitStoreApp';
import { DynamicStyles } from 'Components/DynamicStyles';
import { ThemeProvider } from 'styled-components';
import { theme } from 'Ui';

declare const window: any;

const App = () => {
  const client = init();

  return (
      <AppStyled>
        <Router>
          <ThemeProvider theme={theme}>
            <AuthStore.Provider initialData={client}>
              <ConfigurationStore.Provider initialData={client}>
                <DesignStore.Provider initialData={client}>
                  <UiStore.Provider>
                    <ApolloProvider client={client}>
                      <>
                        <InitiStoreApp />
                        <GlobalStyle />
                        <DynamicStyles />
                        <Routes />
                      </>
                    </ApolloProvider>
                  </UiStore.Provider>
                </DesignStore.Provider>
              </ConfigurationStore.Provider>
            </AuthStore.Provider>
          </ThemeProvider>
        </Router>
      </AppStyled>
  );
};

export default App;
